import { WsMsgType } from 'lib_ts/enums/machine-msg.enum';

/** for components to interact with events */
export class WebSocketHelper {
  // ! deprecate these in favor of interacting with the socket directly
  static on(type: WsMsgType, callback: (message: any) => void) {
    /** callback must be **exactly** what will be provided to removeEventListener */
    document.addEventListener(type, callback);
  }

  // ! deprecate these in favor of interacting with the socket directly
  static dispatch(type: WsMsgType, data: any) {
    document.dispatchEvent(new CustomEvent(type, { detail: data }));
  }

  // ! deprecate these in favor of interacting with the socket directly
  static remove(type: WsMsgType, callback: (message: any) => void) {
    /** callback must be **exactly** what was provided to addEventListener */
    document.removeEventListener(type, callback);
  }
}
